import { Field } from '~/components';
import { useFormikContext } from 'formik';
import React from 'react';
import styled from 'styled-components';
import { colors } from '~/styles';

const Control = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
  color: ${colors.black};
`;

const ProjectNameSelect = styled(Field.SingleSelect)`
  width: 11.5rem;
`;

function LineSettingsProjectNameControl() {
  const { values, setFieldValue } = useFormikContext();

  return (
    <Control>
      Show the project name when the invoice has
      <ProjectNameSelect
        name="excludeProjectOnInvoiceForSingleProject"
        materialPlaceholder={false}
        value={values.excludeProjectOnInvoiceForSingleProject ? 'multiple' : 'one'}
        onChange={({ target: { value } }) =>
          setFieldValue('excludeProjectOnInvoiceForSingleProject', value === 'multiple')
        }>
        <option value="one">one project</option>
        <option value="multiple">multiple projects</option>
      </ProjectNameSelect>
    </Control>
  );
}

export default LineSettingsProjectNameControl;
